import * as yup from 'yup';

// src/helpers/validationSchemas/reports/salesOverviewReportSchema.ts
var salesOverviewReportSchema = yup.object().shape({
  name: yup.string().trim().required("nameRequired"),
  period: yup.string().trim().required("periodRequired"),
  startDate: yup.string().trim().when("period", ([period], schema) => {
    if (period === "custom" /* CUSTOM */) {
      return schema.required("startDateRequired");
    }
    if (period === "specific_date" /* SPECIFIC_DATE */) {
      return schema.required("specificDateRequired");
    }
    return schema.notRequired();
  }),
  endDate: yup.string().trim().when("period", {
    is: "custom" /* CUSTOM */,
    // only required if period is CUSTOM
    then: (schema) => schema.required("endDateRequired").test(
      "endDateBeforeStartDate",
      "endDateBeforeStartDate",
      // Error message
      function(value) {
        const { startDate } = this.parent;
        return !startDate || !value || new Date(value) >= new Date(startDate);
      }
    ),
    otherwise: (schema) => schema.notRequired()
  }),
  scheduleStartDateTime: yup.string().trim().when("isSchedulingEnabled", {
    is: true,
    then: (schema) => schema.required("scheduleStartDateTimeRequired").test(
      // test that is valid date
      "scheduleStartDateTimeRequired",
      "scheduleStartDateTimeRequired",
      (value) => {
        return !value || !isNaN(Date.parse(value));
      }
    ),
    otherwise: (schema) => schema.notRequired()
  }),
  recipients: yup.array().when("isSchedulingEnabled", {
    is: true,
    then: (schema) => schema.required("recipientsRequired").test("recipientsRequired", "recipientsRequired", (value) => {
      return value && value.length > 0;
    }),
    otherwise: (schema) => schema.notRequired()
  })
});

export { salesOverviewReportSchema };
